var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearSkyNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1387 23C12.2053 23 9 19.8016 9 15.8659C9 12.7066 11.1255 9.88911 14.1647 9.01505C14.2966 8.97599 14.4383 9.01506 14.5311 9.10783C14.6289 9.20549 14.6631 9.34222 14.624 9.47406C14.4578 10.0551 14.3699 10.6509 14.3699 11.2368C14.3699 14.7575 17.2381 17.6238 20.761 17.6238C21.3473 17.6238 21.9385 17.5408 22.5249 17.3699C22.6568 17.3308 22.7985 17.3699 22.8913 17.4627C22.9891 17.5603 23.0233 17.6971 22.9842 17.8289C22.1193 20.8759 19.3 23 16.1387 23Z",
    fill: "url(#paint0_linear_4850_108394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4850_108394",
    x1: 11.0497,
    y1: 20.9468,
    x2: 20.9468,
    y2: 11.0497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB63A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CC3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSkyNight);
export default __webpack_public_path__ + "static/media/clear_sky_night.70a9e44e3c25057bdb8883d3d23b884a.svg";
export { ForwardRef as ReactComponent };